module.exports = __webpack_public_path__ + "img/0Q3B7249_FoamcoreMatted.844fce0f.jpg";